import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('value_addition_four_types')
export class ValueAdditionFourType {

  @PrimaryGeneratedColumn("increment",{name:'value_addition_four_id'})
  valueAdditionFourId:number;
 
  @Column("varchar",{
      nullable:false,
      length:10,
      name:"code"
      })
    code:string;

    @Column("varchar",{
      nullable:false,
      length:50,
      name:"name"
      })
    name:string;

    @Column("varchar",{
      nullable:true,
      length:50,
      name:"remarks"
      })
    remarks:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
 
  @OneToMany(type=>ValueAdditionFourType, valueAdditionFourType=>valueAdditionFourType.valueAdditionFourId,{cascade: true})
  valueAdditionFourTypeInfo:ValueAdditionFourType[];
}
